export const LIST_PRODUCTS = 'ListProduct/success';
export const LOADING_LIST_PRODUCTS = 'ListProduct/success';
